export const SPARTAN_PRODUCT_ADAS_LABELS = {
  cta: 'ดูรายละเอียดระบบ ADAS',
} as const;
